import { createApp } from 'vue'
import App from './App.vue'
import router from './app/router'
import { i18n } from './app/i18n'
import { installWebsiteAnalytics } from './app/analytics'
import './style.css'

const app = createApp(App).use(router).use(i18n)
void router.isReady().then(() => {
  app.mount('#app')
  installWebsiteAnalytics(router)
})
